import { render, staticRenderFns } from "./drawer_care.vue?vue&type=template&id=242f1c4d&scoped=true&"
import script from "./drawer_care.vue?vue&type=script&lang=js&"
export * from "./drawer_care.vue?vue&type=script&lang=js&"
import style0 from "./drawer_care.vue?vue&type=style&index=0&id=242f1c4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242f1c4d",
  null
  
)

export default component.exports